export default __webpack_public_path__ + "static/media/rambouillet20.13ed58af.jpg";